<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-end text-secondary pb-2">Indicateurs / FSE</h3>
  </div>

  <form *ngIf="fseDetailsForm" [formGroup]="fseDetailsForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <!-- Nom d'opération -->
      <div class="row">
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary">Nom de l'action</label>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary required">Structure</label>
          <select class="form-select" formControlName="structure" [class.is-invalid]="submitted && fseDetailsForm.controls.structure.invalid">
            <option *ngIf="!fseDetailsForm.value.structure" [ngValue]="" selected hidden></option>

            <!-- If user is admin, all structures as options -->
            <option *ngFor="let structure of structures | displayLabelSort" [ngValue]="structure.id">
              {{ structure.label }}
            </option>
          </select>
          <small *ngIf="submitted && fseDetailsForm.controls?.structure?.errors?.required" class="form-text text-danger">
            La structure est requise.
          </small>
        </div>
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary required">Année</label>
          <select class="form-select" formControlName="year" [class.is-invalid]="submitted && fseDetailsForm.controls.year.invalid">
            <option *ngIf="!fseDetailsForm.value.year" [ngValue]="" selected hidden></option>
            <option *ngFor="let year of years" [ngValue]="year">
              {{ year }}
            </option>
          </select>
          <small *ngIf="submitted && fseDetailsForm.controls?.year?.errors?.required" class="form-text text-danger">L'année est requise</small>
        </div>
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary required">Libellé</label>
          <select class="form-select" formControlName="label" [class.is-invalid]="submitted && fseDetailsForm.controls.label.invalid">
            <option *ngIf="!fseDetailsForm.value.label" [ngValue]="" selected hidden></option>
            <option *ngFor="let label of labels" [ngValue]="label.id">
              {{ label.label }}
            </option>
          </select>
          <small *ngIf="submitted && fseDetailsForm.controls?.label?.errors?.required" class="form-text text-danger">
            L'action collective est requise
          </small>
        </div>
      </div>

      <!-- Indicateurs d'entrée -->
      <div class="card border-1 card-border-radius-0" *ngIf="entryForm" formGroupName="entryForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Indicateurs d'entrée</button>
                </h2>

                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- Date d'entrée -->
                      <div class="row">
                        <div class="mb-3 col-12 col-lg-4">
                          <label class="text-secondary">Date d'entrée</label>
                          <app-datepicker
                            id="fieldEntryDate"
                            formControlName="entryDate"
                            [invalid]="submitted && entryForm.controls?.entryDate?.invalid"
                          ></app-datepicker>
                          <small *ngIf="submitted && entryForm.controls?.entryDate?.errors?.dateFormat" class="form-text text-danger">
                            La date d'entrée est invalide
                          </small>
                          <small *ngIf="submitted && entryForm.controls?.entryDate?.errors?.required" class="form-text text-danger">
                            La date d'entrée est requise
                          </small>
                          <small *ngIf="submitted && entryForm.errors?.datesOrderValue" class="form-text text-danger">
                            La date d'entrée doit être supérieure à la date de début d'orientation
                          </small>
                          <small *ngIf="submitted && entryForm.errors?.notSameYear" class="form-text text-danger">
                            L'année d'entrée doit être la même que l'année de l'action
                          </small>
                        </div>
                      </div>
                      <!-- question 7 -->
                      <div class="row mt-2">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Lieu de naissance en France</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="7Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion7"
                              name="entryQuestion7"
                              value="7Yes"
                            />
                            <label for="7Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="7No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion7"
                              name="entryQuestion7"
                              value="7No"
                            />
                            <label for="7No" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 8 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Activité</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="8a" type="radio" class="form-check-input" formControlName="entryQuestion8" name="entryQuestion8" value="8a" />
                            <label for="8a" class="form-check-label">En scolarité, étudiant</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="8b" type="radio" class="form-check-input" formControlName="entryQuestion8" name="entryQuestion8" value="8b" />
                            <label for="8b" class="form-check-label">Mineur non scolarisé</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="8c" type="radio" class="form-check-input" formControlName="entryQuestion8" name="entryQuestion8" value="8c" />
                            <label for="8c" class="form-check-label">Retraité</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="8d" type="radio" class="form-check-input" formControlName="entryQuestion8" name="entryQuestion8" value="8d" />
                            <label for="8d" class="form-check-label">Autre</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 1 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Statut sur le marché du travail à l'entrée dans l'opération</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1aYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1aYes"
                            />
                            <label for="1aYes" class="form-check-label">Oui, un emploi de travailleur indépendant, chef d'entreprise</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1bYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1bYes"
                            />
                            <label for="1bYes" class="form-check-label">Oui, un emploi durable (CDI ou CDD de 6 mois ou +)</label>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4">
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1cYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1cYes"
                            />
                            <label for="1cYes" class="form-check-label">Oui, un emploi temporaire (intérim, CDD de moins de 6 mois)</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1dYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1dYes"
                            />
                            <label for="1dYes" class="form-check-label">Oui, un emploi aidé (y compris IAE)</label>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4">
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1gYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1gYes"
                            />
                            <label for="1gYes" class="form-check-label">
                              Oui, un emploi en alternance (contrat d'apprentissage ou de professionnalisation)
                            </label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="1No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1"
                              name="entryQuestion1"
                              value="1No"
                            />
                            <label for="1No" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 1f -->
                      <div class="row mt-4" *ngIf="entryFormQ1fIsActive">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>
                              Si vous n’occupez pas d’emploi, recherchez-vous actuellement activement un emploi et êtes-vous disponible dans les 15
                              jours ?
                            </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row" *ngIf="entryFormQ1fIsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1fYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1f"
                              name="entryQuestion1f"
                              value="1fYes"
                            />
                            <label for="1fYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1fNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1f"
                              name="entryQuestion1f"
                              value="1fNo"
                            />
                            <label for="1fNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 1g -->
                      <div class="row" *ngIf="entryFormQ1gIsActive">
                        <div class="mb-3 col-12">
                          <label class="text-secondary required">Si oui, depuis quand cherchez-vous ?</label>
                          <div class="col-lg-4">
                            <app-datepicker
                              id="fieldSearchingSinceDate"
                              formControlName="searchingSince"
                              [invalid]="submitted && entryForm.controls?.searchingSince?.invalid"
                            ></app-datepicker>
                          </div>
                          <small *ngIf="submitted && entryForm.controls?.searchingSince?.errors?.dateFormat" class="form-text text-danger">
                            La date est invalide
                          </small>
                          <small *ngIf="submitted && entryForm.controls?.searchingSince?.errors?.required" class="form-text text-danger">
                            La date est requise
                          </small>
                          <small *ngIf="submitted && fseDetailsForm.errors?.searchingSinceDateOrder" class="form-text text-danger">
                            La date de début de recherche doit être inférieure à la date d'entrée
                          </small>
                        </div>
                      </div>

                      <!-- question 1e -->
                      <div class="row mt-4" *ngIf="entryFormQ1eIsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Si vous n’occupez pas d’emploi, êtes-vous en formation professionnelle ou en stage ?</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="entryFormQ1eIsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1eYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1e"
                              name="entryQuestion1e"
                              value="1eYes"
                            />
                            <label for="1eYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1eNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion1e"
                              name="entryQuestion1e"
                              value="1eNo"
                              [attr.disabled]="question1eValue1NoDisabled ? true : null"
                            />
                            <label for="1eNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 9 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Êtes-vous inscrit à France Travail ?</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="9Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion9"
                              name="entryQuestion9"
                              value="9Yes"
                            />
                            <label for="9Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="9No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion9"
                              name="entryQuestion9"
                              value="9No"
                            />
                            <label for="9No" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 9a -->
                      <div class="row" *ngIf="entryFormQ9aIsActive">
                        <div class="mb-3 col-12">
                          <label class="text-secondary required">Si oui, depuis quelle date ?</label>
                          <div class="col-lg-4">
                            <app-datepicker
                              id="entryQuestion9a"
                              formControlName="entryQuestion9a"
                              [invalid]="submitted && entryForm.controls?.entryQuestion9a?.invalid"
                            ></app-datepicker>
                          </div>
                          <small *ngIf="submitted && entryForm.controls?.entryQuestion9a?.errors?.dateFormat" class="form-text text-danger">
                            La date est invalide
                          </small>
                          <small *ngIf="submitted && entryForm.controls?.entryQuestion9a?.errors?.required" class="form-text text-danger">
                            La date est requise
                          </small>
                        </div>
                      </div>

                      <!-- question 2 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>
                              Quel est le plus haut niveau de diplôme atteint ou l'année d'études la plus élevée à l'entrée dans l'opération ?
                            </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="2a" type="radio" class="form-check-input" formControlName="entryQuestion2" name="entryQuestion2" value="2a" />
                            <label for="2a" class="form-check-label">Vous n’êtes jamais allé(e) à l’école, CITE 0</label>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="2b" type="radio" class="form-check-input" formControlName="entryQuestion2" name="entryQuestion2" value="2b" />
                            <label for="2b" class="form-check-label">
                              Primaire, 6e, 5e, 4e, 3e (1er cycle du secondaire), Brevet des collèges, seconde professionnelle (technique cycle
                              court), CITE 1-2
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="2c" type="radio" class="form-check-input" formControlName="entryQuestion2" name="entryQuestion2" value="2c" />
                            <label for="2c" class="form-check-label">
                              CAP, BEP, 2nd cycle du secondaire : Lycée, Baccalauréat général, technologique, Bac Pro, brevet professionnel (BP), CITE
                              3-4
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input id="2d" type="radio" class="form-check-input" formControlName="entryQuestion2" name="entryQuestion2" value="2d" />
                            <label for="2d" class="form-check-label">
                              DEUG, BTS, DUT, BUT, Institut de formation en soins infirmiers, licence (L3), maîtrise, Grande école, école d’ingénieur,
                              de commerce, master (M1 et M2), DEA, DESS, doctorat, CITE 5-8
                            </label>
                          </div>
                        </div>
                      </div>

                      <!-- question 3 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Avez-vous une reconnaissance officielle d’un handicap (allocation, pension ou carte d’invalidité…) ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="3Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion3"
                              name="entryQuestion3"
                              value="3Yes"
                            />
                            <label for="3Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="3No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion3"
                              name="entryQuestion3"
                              value="3No"
                            />
                            <label for="3No" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 4 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>
                              Êtes-vous allocataire de minima sociaux (RSA, allocation spécifique de solidarité, allocation aux adultes handicapés…) ?
                            </strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="4Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion4"
                              name="entryQuestion4"
                              value="4Yes"
                            />
                            <label for="4Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="4No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion4"
                              name="entryQuestion4"
                              value="4No"
                            />
                            <label for="4No" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- questions 4a -> 4h -->
                      <div *ngIf="entryFormQ4ValuesIsActive">
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong> Si oui, êtes-vous bénéficiaire des aides suivantes ?</strong></p>
                          </div>
                        </div>
                        <div *ngFor="let value of entryQuestion4Values" class="row">
                          <div class="col-4 col-lg-3 col-xl-12">
                            <div class="form-check form-check-inline">
                              <input
                                [id]="'4' + value.letter"
                                type="checkbox"
                                class="form-check-input"
                                [formControlName]="'entryQuestion4' + value.letter"
                                [name]="'entryQuestion4' + value.letter"
                                [value]="'4' + value.letter"
                              />
                              <label [for]="'4' + value.letter" class="form-check-label">{{ value.label }}</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- question 5 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Êtes-vous sans domicile fixe ou confronté à l’exclusion de votre logement ?</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="5Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion5"
                              name="entryQuestion5"
                              value="5Yes"
                            />
                            <label for="5Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="5No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion5"
                              name="entryQuestion5"
                              value="5No"
                            />
                            <label for="5No" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="5DK"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion5"
                              name="entryQuestion5"
                              value="5DK"
                            />
                            <label for="5DK" class="form-check-label">Ne souhaite pas répondre / ne sait pas</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 6 -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Un de vos deux parents est-il né dans un pays actuellement hors de l’Union européenne ?</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="6Yes"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion6"
                              name="entryQuestion6"
                              value="6Yes"
                            />
                            <label for="6Yes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="6No"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion6"
                              name="entryQuestion6"
                              value="6No"
                            />
                            <label for="6No" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="6DK"
                              type="radio"
                              class="form-check-input"
                              formControlName="entryQuestion6"
                              name="entryQuestion6"
                              value="6DK"
                            />
                            <label for="6DK" class="form-check-label">Ne souhaite pas répondre / ne sait pas</label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && entryForm.invalid" class="form-text text-danger">Merci de remplir complètement le formulaire d'entrée</small>
      </div>

      <!-- Indicateurs de sortie -->
      <div class="card border-1 card-border-radius-0 mt-2" formGroupName="exitForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Indicateurs de sortie</button>
                </h2>

                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- Date de sortie -->
                      <div class="row mt-4">
                        <div class="mb-3 col-12 col-lg-4">
                          <label class="text-secondary">Date de sortie</label>
                          <app-datepicker
                            id="fieldExitDate"
                            formControlName="exitDate"
                            [invalid]="submitted && (exitForm.controls?.exitDate?.invalid || exitForm.errors?.datesOrder)"
                          ></app-datepicker>
                          <small *ngIf="submitted && exitForm.controls?.exitDate?.errors?.dateFormat" class="form-text text-danger">
                            La date de sortie est invalide
                          </small>
                          <small *ngIf="submitted && exitForm.controls?.exitDate?.errors?.required" class="form-text text-danger">
                            La date de sortie est requise
                          </small>
                          <small *ngIf="submitted && fseDetailsForm.errors?.datesOrder" class="form-text text-danger">
                            La date de sortie doit être supérieure à la date d'entrée
                          </small>
                        </div>
                      </div>
                      <!-- question 1 -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p><strong>Motif de sortie</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion1"
                              name="exitQuestion1"
                              [value]="true"
                            />
                            <label for="1ExitYes" class="form-check-label">A terminé</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="1ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion1"
                              name="exitQuestion1"
                              [value]="false"
                            />
                            <label for="1ExitNo" class="form-check-label">A abandonné</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 2 -->
                      <div class="row mt-4" *ngIf="exitFormQ2IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Motif de l’abandon</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ2IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="2aExit"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion2"
                              name="exitQuestion2"
                              value="2aExit"
                            />
                            <label for="2aExit" class="form-check-label">A trouvé un emploi, une formation, un stage</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="2bExit"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion2"
                              name="exitQuestion2"
                              value="2bExit"
                            />
                            <label for="2bExit" class="form-check-label">Problèmes de santé, maladie</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="2cExit"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion2"
                              name="exitQuestion2"
                              value="2cExit"
                            />
                            <label for="2cExit" class="form-check-label">Problèmes de garde d'enfant</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="2dExit"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion2"
                              name="exitQuestion2"
                              value="2dExit"
                            />
                            <label for="2dExit" class="form-check-label">Autres raisons (déménagement, décès, etc.)</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 3 liminaire -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Occupe un emploi ?</strong></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="3LExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitLiminaire3"
                              name="exitLiminaire3"
                              [value]="true"
                            />
                            <label for="3LExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="3LExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitLiminaire3"
                              name="exitLiminaire3"
                              [value]="false"
                            />
                            <label for="3LExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>
                      <!-- question 3 -->
                      <div class="row mt-4" *ngIf="isQuestion3Active !== null">
                        <div class="col-12 col-lg-12">
                          <p><strong>Situation sur le marché du travail</strong></p>
                        </div>
                      </div>
                      <div>
                        <div class="row">
                          <div *ngIf="isQuestion3Active === true">
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3aExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3aExit"
                                />
                                <label for="3aExit" class="form-check-label">Accède à une activité d'indépendant, création d'entreprise</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3bExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3bExit"
                                />
                                <label for="3bExit" class="form-check-label">Accède à un emploi durable (CDI ou CDD de + 6 mois)</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3cExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3cExit"
                                />
                                <label for="3cExit" class="form-check-label">Accède à un emploi temporaire (interim, CDD de moins de 6 mois)</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3hExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3hExit"
                                />
                                <label for="3hExit" class="form-check-label">
                                  Accède à un emploi en alternance (contrat d'apprentissage ou de professionnalisation)
                                </label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3dExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3dExit"
                                />
                                <label for="3dExit" class="form-check-label">Accède à un emploi aidé, yc. IAE</label>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="isQuestion3Active === false">
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3eExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3eExit"
                                />
                                <label for="3eExit" class="form-check-label"> Suit des études ou une formation (Accès à la formation)</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3fExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3fExit"
                                />
                                <label for="3fExit" class="form-check-label">En recherche d'emploi sans suivre de formation</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3 col-xl-12">
                              <div class="form-check form-check-inline">
                                <input
                                  id="3gExit"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="exitQuestion3"
                                  name="exitQuestion3"
                                  value="3gExit"
                                />
                                <label for="3gExit" class="form-check-label">
                                  Inactif, ni en emploi, ni en formation, ni en recherche d'emploi
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- question 4 -->
                      <div class="row mt-4" *ngIf="exitFormQ1IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Le participant a obtenu une qualification au terme de sa participation</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ1IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="4ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion4"
                              name="exitQuestion4"
                              value="4ExitYes"
                            />
                            <label for="4ExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="4ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion4"
                              name="exitQuestion4"
                              value="4ExitNo"
                            />
                            <label for="4ExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 5 -->
                      <div class="row mt-4" *ngIf="exitFormQ1IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Le participant a achevé une formation de développement des compétences</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ1IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="5ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion5"
                              name="exitQuestion5"
                              value="5ExitYes"
                            />
                            <label for="5ExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="5ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion5"
                              name="exitQuestion5"
                              value="5ExitNo"
                            />
                            <label for="5ExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 6 -->
                      <div class="row mt-4" *ngIf="exitFormQ1IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Le participant a achevé une formation pré-qualifiante</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ1IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="6ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion6"
                              name="exitQuestion6"
                              value="6ExitYes"
                            />
                            <label for="6ExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12" *ngIf="exitFormQ1IsActive">
                          <div class="form-check form-check-inline">
                            <input
                              id="6ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion6"
                              name="exitQuestion6"
                              value="6ExitNo"
                            />
                            <label for="6ExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 7 -->
                      <div class="row mt-4" *ngIf="exitFormQ1IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Le participant a achevé une formation aux savoirs de base</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ1IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="7ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion7"
                              name="exitQuestion7"
                              value="7ExitYes"
                            />
                            <label for="7ExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="7ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion7"
                              name="exitQuestion7"
                              value="7ExitNo"
                            />
                            <label for="7ExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- question 8 -->
                      <div class="row mt-4" *ngIf="exitFormQ1IsActive">
                        <div class="col-12 col-lg-12">
                          <p><strong>Le participant entame une nouvelle étape du parcours</strong></p>
                        </div>
                      </div>
                      <div class="row" *ngIf="exitFormQ1IsActive">
                        <div class="col-4 col-lg-3 col-xl-12">
                          <div class="form-check form-check-inline">
                            <input
                              id="8ExitYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion8"
                              name="exitQuestion8"
                              value="8ExitYes"
                            />
                            <label for="8ExitYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 col-xl-12" *ngIf="exitFormQ1IsActive">
                          <div class="form-check form-check-inline">
                            <input
                              id="8ExitNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="exitQuestion8"
                              name="exitQuestion8"
                              value="8ExitNo"
                            />
                            <label for="8ExitNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && exitForm.invalid" class="form-text text-danger">Merci de remplir complètement le formulaire de sortie</small>
      </div>
      <small *ngIf="submitted && fseDetailsForm.errors?.entryOrExitDateRequired" class="form-text text-danger">
        Merci de completer les indicateurs d'entrée ou de sortie
      </small>
    </div>
    <!-- Boutons actions -->

    <div class="row px-3">
      <div class="col-6 col-md-12 col-lg-6 mb-1" *ngIf="isCreation"></div>
      <div class="col-3 col-md-6 col-lg-3 mb-1" *ngIf="!isCreation"></div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *ngIf="!isCreation && !structureCantSave()">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="delete()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="trash"></fa-icon>
          <span class="ms-3 d-none d-md-block">Supprimer</span>
        </button>
      </div>

      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button
          class="btn btn-primary d-flex justify-content-center"
          type="button"
          (click)="cancel()"
          *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']"
        >
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *ngIf="!structureCantSave()">
        <button *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']" class="btn btn-primary d-flex justify-content-center" type="submit">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-3 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
    </div>
  </form>
</div>
